import { Suspense } from "react";
import "./home.css";
import { Container, Row, Col } from "react-bootstrap";

import HomeHero from "./sections/hero";
import ChoosePath from "./sections/choose-path";
import Solutions from "./sections/solutions";
import CompanyBenefits from "./sections/home-benefits";
import ServicesList from "./sections/services-list";
import BrandsCarousel from "../../components/carousels/brands-carousel";
import TestimonialCarousel from "../../components/carousels/testimonial-carousel";
import ProductPartners from "../../components/product-partners";
import TestimonialVideoPlayer from "../../components/videos/testimonial-video";
import ContactForm from "../../components/forms/contact-form";
import PortfolioCarousel from "../../components/carousels/portfolio-carousel";
import LoadingScreen from "../../components/loader/loading-screen";
import SentryVideoTestimonial from "../../components/videos/sentry-video";

const HomePage = () => {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <HomeHero />
            <ChoosePath />
            <BrandsCarousel />
            <CompanyBenefits />
            <ServicesList />
            <PortfolioCarousel />
            <Solutions />
            <TestimonialCarousel />
            <Container>
                <Row>
                    <Col xs="12" lg="6">
                        <TestimonialVideoPlayer />
                    </Col>
                    <Col xs="12" lg="6">
                        <SentryVideoTestimonial />
                    </Col>
                </Row>
            </Container>
            <ContactForm />
            <ProductPartners />
        </Suspense>
    );
};

export default HomePage;
